import CONSTANTS from "../CONSTANTS";

export const actionGetAssetsList = (page = 0, limit = 5 , search=null) => ({
  type: CONSTANTS.ASSETS_GET_LIST,
  page,
  limit,
  search
});

export const actionSetAssetsList = (assets) => ({
  type: CONSTANTS.ASSETS_SET_LIST,
  assets,
});

export const actionUpdateAssetInList = (asset, status) => ({
  type: CONSTANTS.ASSETS_UPDATE_LOCAL_ASSET,
  asset,
  status
});

export const actionSetEditAsset = (asset) => ({
  type: CONSTANTS.ASSETS_SET_EDIT,
  asset
});

export const actionAssetSubmitEdition = (data) => ({
  type: CONSTANTS.ASSETS_SUBMIT_EDIT,
  data
})

export const actionAssetSubmitForm = (data) => ({
  type: CONSTANTS.ASSETS_SUBMIT_FORM,
  data
});

export const actionGetAvailableAssets = (page = 0, limit = 5 , search=null, typeFilter=null) => ({
  type: CONSTANTS.ASSETS_GET_AVAILABLE,
  page,
  limit,
  search,
  typeFilter
});

export const actionMarkAssetAsReserved = (assetId, page = 0, limit = 5 , search=null, typeFilter=null) => ({
  type: CONSTANTS.ASSETS_MARK_RESERVED,
  assetId,
  page,
  limit,
  search,
  typeFilter
});

export const actionMarkAssetAsAvailable = (assetId, page = 0, limit = 5 , search=null, typeFilter=null) => ({
  type: CONSTANTS.ASSETS_MARK_AVAILABLE,
  assetId,
  page,
  limit,
  search,
  typeFilter
});

export const actionDeleteAsset = (assetId) => ({
  type: CONSTANTS.ASSETS_DELETE,
  assetId,
});

export const actionSetAvailableAssets = (assets) => ({
  type: CONSTANTS.ASSETS_SET_AVAILABLE,
  assets
});

export const actionGetAssetTypes = () => ({
  type: CONSTANTS.ASSETS_GET_TYPES,
});

export const actionSetAssetTypes = (types) => ({
  type: CONSTANTS.ASSETS_SET_TYPES,
  types
});

export const actionGetAssetStudyTypes = () => ({
  type: CONSTANTS.ASSETS_GET_STUDY_TYPES,
});

export const actionSetAssetStudyTypes = (types) => ({
  type: CONSTANTS.ASSETS_SET_STUDY_TYPES,
  types
});

export const actionGetAssetStateMachine = () => ({
  type: CONSTANTS.ASSETS_GET_STATE_MACHINE,
});

export const actionSetAssetStateMachine = (machine) => ({
  type: CONSTANTS.ASSETS_SET_STATE_MACHINE,
  machine
});

export const actionGetAssetBrands = () => ({
  type: CONSTANTS.ASSETS_GET_BRANDS
});

export const actionSetAssetBrands = (brands) => ({
  type: CONSTANTS.ASSETS_SET_BRANDS,
  brands
});